import { usePushNotifications } from './hooks/usePushNotifications';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SolicitudesPage from './pages/SolicitudesPage';
import SolicitudDetallePage from './pages/SolicitudDetallePage';
import UsuariosPage from './pages/UsuariosPage';
import ReportesPage from './pages/ReportesPage';
import ForcePasswordChangeModal from './components/ForcePasswordChangeModal';

const ROLES_GLOBALES = ['ADMIN', 'DIRECTOR', 'GERENTE'];
const ROLES_GESTORES = ['ADMIN', 'DIRECTOR', 'GERENTE'];

function PrivateRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b', fontFamily: 'Segoe UI' }}>
      Cargando...
    </div>
  );
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/solicitudes" />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  usePushNotifications(user);
  return (
    <>
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/" element={
        <PrivateRoute roles={ROLES_GLOBALES}><DashboardPage /></PrivateRoute>
      } />
      <Route path="/solicitudes" element={
        <PrivateRoute><SolicitudesPage /></PrivateRoute>
      } />
      <Route path="/solicitudes/:id" element={
        <PrivateRoute><SolicitudDetallePage /></PrivateRoute>
      } />
      <Route path="/reportes" element={
        <PrivateRoute roles={ROLES_GLOBALES}><ReportesPage /></PrivateRoute>
      } />
      <Route path="/usuarios" element={
        <PrivateRoute roles={ROLES_GESTORES}><UsuariosPage /></PrivateRoute>
      } />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
    <ForcePasswordChangeModal />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
